module.exports = __webpack_public_path__ + "static/media/bts_lalela_170718_038_small.a7a780d5.jpg";